export default __webpack_public_path__ + "static/media/ph.50f0fe14.svg";